module.exports = __webpack_public_path__ + "static/media/slide-11.30013b6a.png";